<template>
  <div class="batch-pay-fee-order-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-card class="payer-object-card">
          <div class="card-title">收费对象</div>
          <div class="checkbox-list">
            <el-checkbox-group v-model="batchPayFeeOrderInfo.payerObjNames" @change="_chanagePayerObjName">
              <el-checkbox v-for="(item, index) in batchPayFeeOrderInfo.payObjs" :key="index" :label="item"
                class="checkbox-item">{{ item }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card v-loading="loading">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('batchPayFeeOrder.title') }}</span>
            <div>
              <el-button type="warning" size="small" @click="_selectOweFees">仅选欠费</el-button>
              <el-button type="info" size="small" @click="_selectAllFees">全选</el-button>
              <el-button type="primary" size="small" class="float-right" @click="_goBack">{{ $t('common.back')
              }}</el-button>
            </div>
          </div>

          <!-- 顶部操作栏：账户 + 押金 + 缴费金额 + 提交 一行 -->
          <div class="top-bar">
            <pay-fee-user-account ref="payFeeUserAccount" compact
              @changeUserAmountPrice="changeUserAmountPrice"></pay-fee-user-account>
            <pay-fee-deposit ref="payFeeDeposit" compact></pay-fee-deposit>
            <span class="top-total">缴费金额：<span class="amount">{{ batchPayFeeOrderInfo.feePrices }}元</span></span>
            <el-button type="primary" size="small" @click="_openPayFee('common')">{{ $t('batchPayFeeOrder.submitPay') }}</el-button>
          </div>

          <!-- 费用分组列表（可滚动） -->
          <div class="table-scroll-area">
          <div v-for="(group, gIdx) in feeGroups" :key="'group_' + gIdx" class="fee-group-section">
            <div class="group-title">{{ group.payerName }} - {{ group.feeName }}（{{ group.fees.length }}条）</div>
            <el-table :data="group.fees" border style="width: 100%" size="mini"
              @selection-change="(val) => onGroupSelectionChange(val, gIdx)"
              :ref="'feeGroupTable_' + gIdx"
              :row-key="'feeId'">
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column prop="feeName" label="费用项目"
                align="center" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('batchPayFeeOrder.payerObj')" align="center" min-width="120">
                <template slot-scope="scope">
                  {{ _getBatchPayFeeRoomName(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('batchPayFeeOrder.deadline')" align="center" width="120">
                <template slot-scope="scope">
                  {{ _getDeadlineTime(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('batchPayFeeOrder.receivable')" align="center" width="110">
                <template slot-scope="scope">
                  <span>{{ parseFloat(scope.row.receivableAmount || 0).toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('batchPayFeeOrder.isOwe')" align="center" width="80">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.amountOwed && parseFloat(scope.row.amountOwed) > 0"
                    type="danger" size="mini">{{ $t('batchPayFeeOrder.yesOwe') }}</el-tag>
                  <el-tag v-else type="success" size="mini">{{ $t('batchPayFeeOrder.noOwe') }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column :label="$t('batchPayFeeOrder.paymentCycle')" align="center" width="150">
                <template slot-scope="scope">
                  <div v-if="scope.row.feeFlag != '2006012'">
                    <div v-if="scope.row.tempCycle == '-102'" class="cycle-text">周期：{{ scope.row.cycles }}个月</div>
                    <div v-else-if="scope.row.tempCycle == '-101'" class="custom-amount">
                      自定义金额<br>{{ scope.row.receivedAmount }}</div>
                    <div v-else-if="scope.row.tempCycle == '-103'" class="custom-end-time">
                      结束时间<br>{{ scope.row.custEndTime }}</div>
                    <el-select v-else v-model="scope.row.cycles" @change="_changeMonth(scope.row.cycles, scope.row)"
                      style="width:100%">
                      <el-option v-for="item in _getBatchPaymentCycles(scope.row)" :key="item"
                        :label="`${item}${$t('batchPayFeeOrder.month')}`" :value="item"></el-option>
                    </el-select>
                    <el-button type="text" icon="el-icon-setting" @click="_settingsFeeCycle(scope.row)"></el-button>
                  </div>
                  <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('batchPayFeeOrder.actualAmount')" align="center" width="150">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.receivedAmountSwitch == '1'" v-model="scope.row.receivedAmount"
                    :placeholder="$t('batchPayFeeOrder.enterActualAmount')" @change="_doComputeTotalFee"></el-input>
                  <span v-else>{{ scope.row.receivedAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('batchPayFeeOrder.remark')" align="center" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" :placeholder="$t('batchPayFeeOrder.enterRemark')"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div class="subtotal-row">小计：<b>{{ _getGroupSubtotal(group) }}</b> 元</div>
          </div>
          </div>
        </el-card>

      </el-col>
    </el-row>

    <batch-pay-confirm ref="batchPayConfirm" @pay-success="_onPaySuccess"></batch-pay-confirm>
    <batch-fee-cycle ref="batchFeeCycle" @changeMonth="batchChangeMonth"></batch-fee-cycle>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import PayFeeUserAccount from '@/components/fee/payFeeUserAccount'
import PayFeeDeposit from '@/components/fee/payFeeDeposit'
import BatchPayConfirm from '@/components/fee/batchPayConfirm'
import BatchFeeCycle from '@/components/fee/batchFeeCycle'
import { listFee, listFeeObj } from '@/api/fee/batchPayFeeOrderApi'
import { listFeeAmountSummary } from '@/api/fee/feeAmountSummaryApi'
import { queryOwnerCars } from '@/api/simplify/simplifyCarFeeApi'
import { dateFormat, dateAdd } from '@/utils/dateUtil'

export default {
  name: 'BatchPayFeeOrderList',
  components: {
    PayFeeUserAccount,
    PayFeeDeposit,
    BatchPayConfirm,
    BatchFeeCycle
  },
  data() {
    return {
      loading: false,
      batchPayFeeOrderInfo: {
        batchFees: [],
        allBatchFees: [],
        selectPayFeeIds: [],
        feePrices: 0.00,
        communityId: '',
        ownerId: '',
        payerObjType: '',
        remark: '',
        payerObjNames: [],
        payObjs: [],
        accountAmount: 0.0,
        acctId: '',
        acctType: ''
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._initData()
  },
  computed: {
    // 按收费对象 + 费用名称分组，不同车辆/房屋分开显示
    feeGroups() {
      const map = {}
      const fees = this.batchPayFeeOrderInfo.batchFees
      fees.forEach(fee => {
        const payerName = this._getBatchPayFeeRoomName(fee) || '未知对象'
        const feeName = fee.feeName || '其他费用'
        const key = `${payerName}||${feeName}`
        if (!map[key]) map[key] = []
        map[key].push(fee)
      })
      return Object.keys(map).map(key => {
        const parts = key.split('||')
        map[key].sort((a, b) => {
          const tA = a.startTime ? new Date(a.startTime).getTime() : 0
          const tB = b.startTime ? new Date(b.startTime).getTime() : 0
          return tA - tB
        })
        return {
          payerName: parts[0],
          feeName: parts[1],
          fees: map[key]
        }
      })
    }
  },
  methods: {
    // 分组表格选择变化
    onGroupSelectionChange(selection, gIdx) {
      // 收集该组的选择
      const groupFeeIds = selection.map(item => item.feeId)
      // 移除该组旧的选择，加入新选择
      const otherIds = this.batchPayFeeOrderInfo.selectPayFeeIds.filter(id => {
        const group = this.feeGroups[gIdx]
        return group && !group.fees.some(f => f.feeId === id)
      })
      this.batchPayFeeOrderInfo.selectPayFeeIds = [...otherIds, ...groupFeeIds]
      this._doComputeTotalFee()
    },

    // 设置所有分组表格的选中状态
    setTableSelection() {
      this.$nextTick(() => {
        this.feeGroups.forEach((group, idx) => {
          const tableRef = this.$refs['feeGroupTable_' + idx]
          if (tableRef && tableRef[0]) {
            group.fees.forEach(row => {
              if (this.batchPayFeeOrderInfo.selectPayFeeIds.includes(row.feeId)) {
                tableRef[0].toggleRowSelection(row, true)
              }
            })
          }
        })
      })
    },

    async _initData() {
      const ownerId = this.$route.query.ownerId
      const carId = this.$route.query.carId
      const roomId = this.$route.query.roomId
      const payerObjType = this.$route.query.payerObjType
      const carNum = this.$route.query.carNum
      const roomName = this.$route.query.roomName
      const selectedFeeIds = this.$route.query.selectedFeeIds || ''

      // 车辆页面：通过 carId 查询费用（只查当前车辆）
      if (carId) {
        this.batchPayFeeOrderInfo.communityId = this.communityId
        this.batchPayFeeOrderInfo.carId = carId
        this.batchPayFeeOrderInfo.carNum = carNum || ''
        this.batchPayFeeOrderInfo.payerObjType = payerObjType || '6666'
        this.batchPayFeeOrderInfo.payerObjId = carId
        this.batchPayFeeOrderInfo._preselectedFeeIds = selectedFeeIds

        await this._loadBatchFees()

        // 有业主ID时加载账户/押金组件，支持预存款抵扣
        this._openAccountIfOwner(ownerId)
        return
      }

      // 房屋页面：通过 roomId 查询房屋费用 + 该房屋绑定的车辆费用
      if (roomId) {
        this.batchPayFeeOrderInfo.communityId = this.communityId
        this.batchPayFeeOrderInfo.roomId = roomId
        this.batchPayFeeOrderInfo.roomName = roomName || ''
        this.batchPayFeeOrderInfo.payerObjType = payerObjType || '3333'
        this.batchPayFeeOrderInfo.payerObjId = roomId
        this.batchPayFeeOrderInfo._preselectedFeeIds = selectedFeeIds

        await this._loadBatchFees()
        // 加载该房屋绑定的车辆费用
        await this._loadRoomCarFees(roomId)

        // 有业主ID时加载账户/押金组件，支持预存款抵扣
        this._openAccountIfOwner(ownerId)
        return
      }

      if (!ownerId) {
        this.$message.warning('未选择缴费对象（业主），请从房屋收费页面进入批量缴费')
        this.$router.go(-1)
        return
      }

      this.batchPayFeeOrderInfo.communityId = this.communityId
      this.batchPayFeeOrderInfo.ownerId = ownerId
      // 不限制 payerObjType，同时加载房屋(3333)和车辆(6666)费用
      this.batchPayFeeOrderInfo.payerObjType = ''
      this.batchPayFeeOrderInfo._preselectedFeeIds = selectedFeeIds

      await this._loadBatchFees()

      setTimeout(() => {
        this.$refs.payFeeUserAccount.open({ ownerId: this.batchPayFeeOrderInfo.ownerId })
        this.$refs.payFeeDeposit.open({ payerObjId: this.batchPayFeeOrderInfo.ownerId, payerObjType: '3333' })
      }, 1000)
    },

    // 有业主ID时加载账户/押金组件，否则跳过
    _openAccountIfOwner(ownerId) {
      if (ownerId) {
        this.batchPayFeeOrderInfo.ownerId = ownerId
        setTimeout(() => {
          this.$refs.payFeeUserAccount.open({ 
            ownerId: ownerId,
            roomId: this.batchPayFeeOrderInfo.roomId || ''
          })
          this.$refs.payFeeDeposit.open({ payerObjId: ownerId, payerObjType: '3333' })
        }, 1000)
      }
    },

    async _loadBatchFees() {
      this.loading = true
      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.communityId,
          state: '2008001',
          orderBy: 'start_time'
        }
        // payerObjType 为空时不传，查询该业主所有类型费用（房屋+车辆）
        if (this.batchPayFeeOrderInfo.payerObjType) {
          params.payerObjType = this.batchPayFeeOrderInfo.payerObjType
        }
        // 有 payerObjId 时按具体对象查询（不含 ownerId，避免查到业主其他房屋费用）
        if (this.batchPayFeeOrderInfo.payerObjId) {
          params.payerObjId = this.batchPayFeeOrderInfo.payerObjId
        }
        // 无 payerObjId 的纯业主模式：通过 ownerId 查询业主所有费用
        if (this.batchPayFeeOrderInfo.ownerId && !this.batchPayFeeOrderInfo.payerObjId) {
          params.ownerId = this.batchPayFeeOrderInfo.ownerId
        }

        const res = await listFee(params)

        let _batchFees = []
        let _selectPayFeeIds = []
        const zeroPriceFees = [] // feeTotalPrice 为 0 的费用

        res.fees.forEach(feeItem => {
          const receivable = parseFloat(feeItem.feeTotalPrice || 0)
          const entry = {
            ...feeItem,
            cycles: feeItem.paymentCycle,
            receivableAmount: receivable,
            receivedAmount: receivable,
            tempCycle: '-100'
          }
          _batchFees.push(entry)

          // 默认不勾选任何费用项

          // 收集 feeTotalPrice 为 0 的费用，后续通过 listFeeObj 补充
          if (receivable === 0) {
            zeroPriceFees.push(entry)
          }
        })

        // 对 feeTotalPrice 为 0 的行，调用 listFeeObj 获取正确的应收金额
        if (zeroPriceFees.length > 0) {
          await this._fillZeroPriceFees(zeroPriceFees)
        }

        // 部分缴费扣减：批量查历史已收+减免，从应收里扣减，只显示剩余欠款
        await this._deductHistoryReceivedBatch(_batchFees)

        this.batchPayFeeOrderInfo = {
          ...this.batchPayFeeOrderInfo,
          allBatchFees: _batchFees,
          selectPayFeeIds: _selectPayFeeIds,
          batchFees: _batchFees
        }

        // 如果从欠费列表跳转过来带了预选feeIds，覆盖默认勾选
        if (this.batchPayFeeOrderInfo._preselectedFeeIds) {
          const preIds = this.batchPayFeeOrderInfo._preselectedFeeIds.split(',').filter(id => id)
          if (preIds.length > 0) {
            this.batchPayFeeOrderInfo.selectPayFeeIds = preIds
          }
        }

        this._pushPayObjs()
        this._doComputeTotalFee()

        // 设置表格选中状态
        this.setTableSelection()
      } catch (error) {
        console.error('请求失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 部分缴费扣减：批量查历史已收+减免，从每条费用的应收里扣减，只显示剩余欠款
    // 例：某费用全额45.8已交25，则批量缴费页应收列显示20.8
    async _deductHistoryReceivedBatch(feeList) {
      if (!feeList || feeList.length === 0) return
      const feeIds = feeList.map(f => f.feeId).filter(id => id)
      if (feeIds.length === 0) return
      try {
        console.log('[batchPay] 开始批量查已收，feeIds:', feeIds.join(','))
        const res = await listFeeAmountSummary({
          communityId: this.batchPayFeeOrderInfo.communityId,
          feeIds: feeIds.join(',')
        })
        console.log('[batchPay] listFeeAmountSummary 原始返回:', JSON.stringify(res))
        // 响应格式 {code:0, data:[...]}，失败时 data 可能不存在
        const list = (res && res.code === 0 && Array.isArray(res.data)) ? res.data : (Array.isArray(res) ? res : [])
        console.log('[batchPay] 解析后 list 长度:', list.length, 'list:', JSON.stringify(list))
        if (list.length === 0) {
          console.log('[batchPay] API 返回空或出错，保持全额显示')
          return
        }
        const map = {}
        list.forEach(item => { map[item.feeId] = item })
        feeList.forEach(fee => {
          const m = map[fee.feeId]
          if (!m) {
            console.log('[batchPay] feeId', fee.feeId, '无已收记录，保持全额', fee.receivableAmount)
            return
          }
          // 已抵扣 = 历史实收 + 减免（不重复算已开票，因已确认收据金额已在实收里）
          const alreadyCovered = parseFloat(m.receivedAmount || 0) + parseFloat(m.deductionAmount || 0)
          const fullAmount = parseFloat(fee.receivableAmount || 0)
          const remaining = fullAmount - alreadyCovered
          console.log('[batchPay] feeId:', fee.feeId, '全额:', fullAmount, '已收:', m.receivedAmount, '减免:', m.deductionAmount, '剩余:', remaining)
          if (remaining > 0 && remaining < fullAmount) {
            // 部分缴费：应收只显示剩余欠款
            fee.receivableAmount = remaining.toFixed(2)
            fee.receivedAmount = remaining.toFixed(2)
          } else if (remaining <= 0) {
            // 已缴清或多缴：显示实际剩余（负数表示多缴/可退）
            fee.receivableAmount = remaining.toFixed(2)
            fee.receivedAmount = remaining.toFixed(2)
            fee.amountOwed = remaining.toFixed(2)
          }
        })
      } catch (e) {
        console.error('[batchPay] 批量查历史已收失败，按全额显示:', e)
      }
    },

    // 对 feeTotalPrice 为 0 的费用，并发调用 listFeeObj 获取实际应收金额
    async _fillZeroPriceFees(zeroPriceFees) {
      const concurrency = 6
      for (let i = 0; i < zeroPriceFees.length; i += concurrency) {
        const batch = zeroPriceFees.slice(i, i + concurrency)
        await Promise.all(
          batch.map(async (fee) => {
            try {
              const objParams = {
                communityId: this.communityId,
                feeId: fee.feeId,
                page: 1,
                row: 1,
                cycle: fee.paymentCycle || 1
              }
              const objRes = await listFeeObj(objParams)
              if (objRes.code === 0 && objRes.data && objRes.data.feeTotalPrice) {
                const price = parseFloat(objRes.data.feeTotalPrice)
                fee.receivableAmount = price
                fee.receivedAmount = price
              }
            } catch (e) {
              console.error('获取费用金额失败:', fee.feeId, e)
            }
          })
        )
      }
    },

    // 加载房屋绑定的车辆费用（纯房屋模式补充车辆费用）
    async _loadRoomCarFees(roomId) {
      try {
        const carRes = await queryOwnerCars({
          page: 1,
          row: 50,
          carTypeCd: '1001',
          communityId: this.communityId,
          roomId: roomId
        })
        const cars = (carRes.data && carRes.data.data) || []
        if (cars.length === 0) return

        const carFeeList = []
        for (const car of cars) {
          const feeParams = {
            page: 1,
            row: 200,
            communityId: this.communityId,
            payerObjId: car.carId,
            payerObjType: '6666',
            state: '2008001',
            orderBy: 'start_time'
          }
          const feeRes = await listFee(feeParams)
          const fees = feeRes.fees || []
          fees.forEach(fee => {
            const receivable = parseFloat(fee.feeTotalPrice || 0)
            carFeeList.push({
              ...fee,
              cycles: fee.paymentCycle,
              receivableAmount: receivable,
              receivedAmount: receivable,
              tempCycle: '-100'
            })
          })
        }

        if (carFeeList.length === 0) return

        // 合并到现有费用列表
        const merged = [...this.batchPayFeeOrderInfo.allBatchFees, ...carFeeList]
        this.batchPayFeeOrderInfo.allBatchFees = merged
        this.batchPayFeeOrderInfo.batchFees = merged

        // 补充零金额费用
        const zeroPriceCars = carFeeList.filter(f => parseFloat(f.receivableAmount || 0) === 0)
        if (zeroPriceCars.length > 0) {
          await this._fillZeroPriceFees(zeroPriceCars)
        }

        // 部分缴费扣减：车辆费用也扣减历史已收
        await this._deductHistoryReceivedBatch(carFeeList)

        this._pushPayObjs()
        this._doComputeTotalFee()
        this.setTableSelection()
      } catch (e) {
        console.error('加载房屋车辆费用失败:', e)
      }
    },

    _batchRoomFeeCompare(a, b) {
      const timeA = new Date(a.startTime).getTime()
      const timeB = new Date(b.startTime).getTime()
      if (timeA < timeB) return -1
      if (timeA > timeB) return 1
      return 0
    },

    _pushPayObjs() {
      const _allBatchFees = this.batchPayFeeOrderInfo.allBatchFees
      const _payObjs = []
      const _payerObjNames = []

      _allBatchFees.forEach(fee => {
        let _payerObjName = ''
        // 优先从 feeAttrs 中读取 390012（付费对象名称）
        if (fee.feeAttrs) {
          fee.feeAttrs.forEach(item => {
            if (item.specCd === '390012' && item.value) {
              _payerObjName = item.value
            }
          })
        }
        // 兜底1：使用 payerObjName（车辆费用=车牌号，非账单模式）
        if (!_payerObjName && fee.payerObjName) {
          _payerObjName = fee.payerObjName
        }
        // 兜底2：使用路由传入的车牌号（纯车牌批量缴费场景）
        if (!_payerObjName && fee.payerObjType === '6666' && this.batchPayFeeOrderInfo.carNum) {
          _payerObjName = this.batchPayFeeOrderInfo.carNum
        }
        // 兜底3：使用路由传入的房屋名（纯房屋无业主批量缴费场景）
        if (!_payerObjName && this.batchPayFeeOrderInfo.roomName) {
          _payerObjName = this.batchPayFeeOrderInfo.roomName
        }
        // 兜底4：payerObjId
        if (!_payerObjName) {
          _payerObjName = fee.payerObjId || ''
        }
        if (!_payerObjName) return

        if (!this._hasPayObjsIn(_payerObjName, _payObjs)) {
          _payObjs.push(_payerObjName)
          _payerObjNames.push(_payerObjName)
        }
      })

      this.batchPayFeeOrderInfo.payObjs = _payObjs
      this.batchPayFeeOrderInfo.payerObjNames = _payerObjNames
    },

    _hasPayObjsIn(payerObjName, payObjs) {
      return payObjs.includes(payerObjName)
    },

    _hasPayObjNamesIn(payerObjName) {
      return this.batchPayFeeOrderInfo.payerObjNames.includes(payerObjName)
    },

    _chanagePayerObjName() {
      const _allBatchFees = this.batchPayFeeOrderInfo.allBatchFees
      const _batchFees = []

      _allBatchFees.forEach(fee => {
        let _payerObjName = ''
        if (fee.feeAttrs) {
          fee.feeAttrs.forEach(item => {
            if (item.specCd === '390012' && item.value) {
              _payerObjName = item.value
            }
          })
        }
        // 兜底1：payerObjName
        if (!_payerObjName && fee.payerObjName) {
          _payerObjName = fee.payerObjName
        }
        // 兜底2：路由传入的车牌号
        if (!_payerObjName && fee.payerObjType === '6666' && this.batchPayFeeOrderInfo.carNum) {
          _payerObjName = this.batchPayFeeOrderInfo.carNum
        }
        // 兜底3：路由传入的房屋名
        if (!_payerObjName && this.batchPayFeeOrderInfo.roomName) {
          _payerObjName = this.batchPayFeeOrderInfo.roomName
        }
        // 兜底4：payerObjId
        if (!_payerObjName) {
          _payerObjName = fee.payerObjId || ''
        }

        if (_payerObjName && this._hasPayObjNamesIn(_payerObjName)) {
          _batchFees.push(fee)
        }
      })

      this.batchPayFeeOrderInfo.batchFees = _batchFees

      // 更新 selectPayFeeIds，只保留当前显示的费用ID
      const currentFeeIds = _batchFees.map(fee => fee.feeId)
      this.batchPayFeeOrderInfo.selectPayFeeIds = this.batchPayFeeOrderInfo.selectPayFeeIds.filter(id =>
        currentFeeIds.includes(id)
      )

      this._doComputeTotalFee()

      // 重新设置表格选中状态
      this.setTableSelection()
    },

    _openPayFee(payType) {
      if (this.batchPayFeeOrderInfo.selectPayFeeIds.length <= 0) {
        this.$message.warning('未选择费用')
        return
      }

      const _payerObjName = this.batchPayFeeOrderInfo.payerObjNames.join(',')
      const params = {
        fees: this._getPayFees(),
        payType: payType,
        feePrices: this.batchPayFeeOrderInfo.feePrices,
        payerObjName: _payerObjName,
        acctId: this.batchPayFeeOrderInfo.acctId,
        acctType: this.batchPayFeeOrderInfo.acctType || '',
        accountAmount: this.batchPayFeeOrderInfo.accountAmount
      }

      this.$refs.batchPayConfirm.open(params)
    },

    _getPayFees() {
      const _selectPayFeeIds = this.batchPayFeeOrderInfo.selectPayFeeIds
      const _batchFees = this.batchPayFeeOrderInfo.batchFees
      const _fees = []

      _selectPayFeeIds.forEach(id => {
        _batchFees.forEach(fee => {
          if (id === fee.feeId) {
            _fees.push(fee)
          }
        })
      })

      return _fees
    },

    _goBack() {
      this.$router.go(-1)
    },
    _onPaySuccess() {
      this._loadBatchFees()
    },

    // 全选当前所有分组表格中的费用项
    _selectAllFees() {
      const allBatchFees = this.batchPayFeeOrderInfo.allBatchFees
      this.batchPayFeeOrderInfo.selectPayFeeIds = allBatchFees.map(f => f.feeId)
      this.$nextTick(() => {
        this.feeGroups.forEach((group, idx) => {
          const tableRef = this.$refs['feeGroupTable_' + idx]
          if (tableRef && tableRef[0]) {
            tableRef[0].clearSelection()
            group.fees.forEach(row => {
              tableRef[0].toggleRowSelection(row, true)
            })
          }
        })
      })
      this._doComputeTotalFee()
    },

    // 仅选当前分组表格中有实际欠费的项
    _selectOweFees() {
      this.batchPayFeeOrderInfo.selectPayFeeIds = this.batchPayFeeOrderInfo.batchFees
        .filter(f => f.amountOwed && parseFloat(f.amountOwed) > 0)
        .map(f => f.feeId)
      this.$nextTick(() => {
        this.feeGroups.forEach((group, idx) => {
          const tableRef = this.$refs['feeGroupTable_' + idx]
          if (tableRef && tableRef[0]) {
            tableRef[0].clearSelection()
            group.fees.forEach(row => {
              if (row.amountOwed && parseFloat(row.amountOwed) > 0) {
                tableRef[0].toggleRowSelection(row, true)
              }
            })
          }
        })
      })
      this._doComputeTotalFee()
    },

    _getDeadlineTime(fee) {
      if (fee.amountOwed === 0 && fee.endTime === fee.deadlineTime) return "-"
      if (fee.state === '2009001') return "-"
      return dateFormat(fee.deadlineTime)
    },

    _getEndTime(fee) {
      if (fee.state === '2009001') return "-"
      const startTime = dateFormat(fee.startTime)
      const start = new Date(fee.startTime).getTime()
      const end = new Date(fee.endTime).getTime()
      let displayEnd
      if (start === end || !fee.endTime) {
        displayEnd = fee.deadlineTime ? dateFormat(fee.deadlineTime) : startTime
      } else {
        displayEnd = dateFormat(fee.endTime)
      }
      return startTime + '~' + displayEnd
    },

    _getBatchPayFeeRoomName(fee) {
      // 优先从 feeAttrs 中读取 390012（付费对象名称）  
      if (fee.feeAttrs) {
        for (let item of fee.feeAttrs) {
          if (item.specCd === '390012' && item.value) {
            return item.value
          }
        }
      }
      // 兜底1：使用 payerObjName（车辆费用=车牌号，非账单模式）
      if (fee.payerObjName) return fee.payerObjName
      // 兜底2：使用路由传入的车牌号（纯车牌批量缴费场景）
      if (fee.payerObjType === '6666' && this.batchPayFeeOrderInfo.carNum) {
        return this.batchPayFeeOrderInfo.carNum
      }
      // 兜底3：使用路由传入的房屋名（纯房屋无业主批量缴费场景）
      if (this.batchPayFeeOrderInfo.roomName) {
        return this.batchPayFeeOrderInfo.roomName
      }
      // 兜底4：payerObjId
      return fee.payerObjId || ''
    },

    _getBatchPaymentCycles(fee) {
      const paymentCycles = []
      for (let i = 1; i < 13; i++) {
        paymentCycles.push(i * parseFloat(fee.paymentCycle))
      }
      return paymentCycles
    },

    _doComputeTotalFee() {
      const _selectPayFeeIds = this.batchPayFeeOrderInfo.selectPayFeeIds
      const _batchFees = this.batchPayFeeOrderInfo.batchFees
      const _accountAmount = parseFloat(this.batchPayFeeOrderInfo.accountAmount || 0)
      const _acctType = this.batchPayFeeOrderInfo.acctType || '2003'

      let _totalFee = 0
      let _deductibleTotal = 0 // 可被当前账户抵扣的费用总额

      _selectPayFeeIds.forEach(id => {
        _batchFees.forEach(fee => {
          if (id === fee.feeId && fee.receivedAmount) {
            const amount = parseFloat(fee.receivedAmount)
            _totalFee += amount
            // 判断此费用是否可被当前账户类型抵扣
            if (this._isFeeMatchAcctType(_acctType, fee.feeTypeCd)) {
              _deductibleTotal += amount
            }
          }
        })
      })

      if (_accountAmount) {
        // 实际可抵扣金额 = min(账户余额, 可抵扣费用总额)
        const actualDeduct = Math.min(_accountAmount, _deductibleTotal)
        _totalFee = Math.max(0, _totalFee - actualDeduct)
      }

      this.batchPayFeeOrderInfo.feePrices = _totalFee.toFixed(2)
    },

    /**
     * 判断费用类型是否匹配账户类型
     * @param {string} acctType   账户类型 2003/2004/2005/2006
     * @param {string} feeTypeCd  费用类型编码
     */
    _isFeeMatchAcctType(acctType, feeTypeCd) {
      if (acctType === '2003') return true // 通用账户抵扣所有
      if (acctType === '2004') return feeTypeCd === '888800010001' // 物业费
      if (acctType === '2005') return ['888800010015', '888800010016', '888800010009'].includes(feeTypeCd) // 水电煤
      if (acctType === '2006') return feeTypeCd === '888800010017' // 公摊费
      return false
    },

    async _changeMonth(cycles, fee) {
      if (!cycles) {
        cycles = fee.cycles
      }

      if (fee.tempCycle === '-101') {
        this._doComputeTotalFee()
        return
      }

      try {
        const params = {
          communityId: this.communityId,
          feeId: fee.feeId,
          page: 1,
          row: 1,
          cycle: cycles
        }

        if (fee.tempCycle === '-103') {
          params.custEndTime = dateAdd(fee.custEndTime)
        }

        const res = await listFeeObj(params)
        if (res.code === 0) {
          fee.receivableAmount = res.data.feeTotalPrice
          fee.receivedAmount = fee.receivableAmount
          this._doComputeTotalFee()
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },

    _settingsFeeCycle(batchFee) {
      this.$refs.batchFeeCycle.open(batchFee)
    },
    _getGroupSubtotal(group) {
      let total = 0
      group.fees.forEach(fee => {
        if (this.batchPayFeeOrderInfo.selectPayFeeIds.includes(fee.feeId) && fee.receivedAmount) {
          total += parseFloat(fee.receivedAmount)
        }
      })
      return total.toFixed(2)
    },
    changeUserAmountPrice(data) {
      this.batchPayFeeOrderInfo.accountAmount = data.totalUserAmount;
      if (data.selectAccount && data.selectAccount.length > 0) {
        data.selectAccount.forEach(_acct => {
          this.batchPayFeeOrderInfo.acctId = _acct.acctId;
          this.batchPayFeeOrderInfo.acctType = _acct.acctType || '';
        })
      }
      this._doComputeTotalFee();
    },
    batchChangeMonth(fee) {
      this._changeMonth(fee.cycle, fee)
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-pay-fee-order-container {
  padding: 20px;

  .payer-object-card {
    height: 100%;

    .card-title {
      padding: 10px;
      font-weight: bold;
    }

    .checkbox-list {
      padding: 10px;

      .checkbox-item {
        display: block;
        margin: 5px 0;
      }
    }
  }

  .footer-row {
    margin-top: 20px;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;

    .tips {
      color: #666;
      line-height: 1.6;
    }

    .total-amount {
      font-size: 16px;

      .amount {
        font-size: 30px;
        color: #f56c6c;
        margin-left: 5px;
      }
    }
  }

  .cycle-text,
  .custom-amount,
  .custom-end-time {
    line-height: 1.5;
    padding: 5px 0;
  }

  .fee-group-section {
    margin-bottom: 10px;

    .group-title {
      font-size: 14px;
      font-weight: bold;
      padding: 6px 10px;
      margin-bottom: 2px;
      background: #f5f7fa;
      border-left: 3px solid #409EFF;
      color: #303133;
    }

    .subtotal-row {
      text-align: right;
      padding: 6px 12px;
      background: #fdf6ec;
      border: 1px solid #EBEEF5;
      border-top: none;
      font-size: 13px;
      color: #E6A23C;
    }
  }

  .table-scroll-area {
    max-height: calc(100vh - 320px);
    overflow-y: auto;
  }

  .top-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
    padding: 10px 16px;
    background: #f5f7fa;
    border-radius: 6px;

    .top-total {
      font-size: 16px;
      font-weight: bold;
      white-space: nowrap;
      margin-left: auto;

      .amount {
        font-size: 22px;
        color: #F56C6C;
        margin-left: 4px;
      }
    }
  }
}
</style>